import React from "react";

/** Settings: a gear. */
const SettingsIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.3 3.5h3.4l.5 2.3a6.6 6.6 0 0 1 1.7 1l2.2-.8 1.7 2.9-1.7 1.6a6.7 6.7 0 0 1 0 2l1.7 1.6-1.7 2.9-2.2-.8a6.6 6.6 0 0 1-1.7 1l-.5 2.3h-3.4l-.5-2.3a6.6 6.6 0 0 1-1.7-1l-2.2.8-1.7-2.9 1.7-1.6a6.7 6.7 0 0 1 0-2L4.2 8.9l1.7-2.9 2.2.8a6.6 6.6 0 0 1 1.7-1l.5-2.3Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="2.6" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  );
};

export default SettingsIcon;
